var checkVisibility = function checkVisibility(elm) {
  var item = elm.getBoundingClientRect();
  return item.top >= 0 && item.left >= 0 && item.bottom <= (window.innerHeight || document.documentElement.clientHeight) && item.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var toggleStickyATC = function toggleStickyATC(reference, sticky) {
  if (checkVisibility(reference)) {
    sticky.classList.remove('visible');
  } else {
    sticky.classList.add('visible');
  }
};
var stickyAddToCart = function stickyAddToCart() {
  var stickyRibbon = document.querySelector('#sticky-atc-js');
  var productATCButton = document.querySelector('#product-atc-js');
  if (!stickyRibbon) {
    return;
  }
  window.addEventListener('scroll', function () {
    toggleStickyATC(productATCButton, stickyRibbon);
  });
};
export { stickyAddToCart };